module.exports = __webpack_public_path__ + "static/media/Forms.5db34cc5.jpg";